<wms-dialog-header [showClose]="false" title="{{locale.TITLE_SOURCE_CODE_UPDATES}}"></wms-dialog-header>
<wms-dialog-body>
  <div class="wm-form">
    <div class="errorMessageContainer">
      <wms-message [scopeDataset]="statusMessages" hideclose="true"></wms-message>
    </div>
    <table class="wm-table source-code-updates-table">
      <colgroup>
        <col width="180">
        <col>
        <col width="150">
        <col>
      </colgroup>
      <thead>
        <tr>
          <th>{{locale.LABEL_NAME}}</th>
          <th>{{locale.LABEL_DESCRIPTION}}</th>
          <th>{{locale.LABEL_ACTIONS}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let update of sourceCodeUpdates ">
          <td>{{update.data.serviceId}}</td>
          <td>{{update.discription}}</td>
          <td>
            <button (click)="updateSourceCode(update)"
                    *ngIf="!update.resolved"
                    [disabled]="disableDialogActions"
                    class="button-primary btn app-button">{{locale.LABEL_UPDATE}}</button>
            <i *ngIf="update.resolved" class="wms wms-done-bold"></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</wms-dialog-body>
<wms-dialog-footer>
  <button (click)="closeDialog()" [disabled]="disableDialogActions"
          [title]="locale['LABEL_CLOSE']"
          class="app-button btn btn-primary"
          name="project-changes-cancel">{{locale.LABEL_CLOSE}}</button>
</wms-dialog-footer>
